module.exports = __webpack_public_path__ + "media/product/i-4-d4aa7293.png";